import type { HTMLAttributes } from "react";

type BadgeProps = HTMLAttributes<HTMLSpanElement> & { variant?: "default" | "secondary" | "destructive" | "outline" };

/** shadcn 风格状态徽章。 */
export function Badge({ className = "", variant = "default", ...props }: BadgeProps) {
  return <span data-slot="badge" data-variant={variant} className={`fm-shadcn-badge ${className}`.trim()} {...props} />;
}
